<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <v-tab :to="{ name: 'page-config' }" ripple>{{ $t('Page Config') }}</v-tab>
      <template v-if="selectedBot.theme == 'warroom'">
        <v-tab :to="{ name: 'warroom-config' }" ripple>{{ $t('Warroom Config') }}</v-tab>
      </template>
    </v-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      currentView: 'page-config'
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/AdvancedSetting/MainMenu.vue